import { Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkspaceLoadingService extends InjectableSuperclass {
  isLoading$ = new BehaviorSubject(false);
  withOverlay$ = new BehaviorSubject(true);

  private reset$ = new Subject<void>();

  async resetWorkspace() {
    this.reset$.next();
  }

  onReset(callback: () => void) {
    this.subscribeTo(this.reset$, callback);
  }
}
